import { gql } from "@apollo/client";

export const UPDATE_APPOINTMENT = gql`
  mutation update($data: UpdateAppointmentRequestInput!) {
    updateAppointment(
      appointmentData: $data,
    ) {
      success,
      messages
    }
  }
`;

export const CANCEL_AND_ADD_APPOINTMENT = gql`
  mutation update($data: CancelAndAddAppointmentRequestInput!) {
    cancelAndAddAppointment(
      appointmentData: $data,
    ) {
      appointmentId,
      start_at,
      end_at,
      startDateTime,
      endDateTime,
      duration,
      reasonsForVisit,
      appointmentCreateType,
      appointmentType,
      resources{
      id,
      name,
      },
      active,
      pets {
       id,
              name,
              image,
              speciesName,
              breedName,
              species,
              breed,
              gender,
              reasonForVisit,
      },
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        timeZone,
      },
      success,
      messages,
      promoCode
    }
  }
`;

